<template>
  <div>
    <!-- 直播卡片表单 -->
    <div class="form-container">
      <el-form class="liveForm" :model="liveForm" :rules="rules" ref="liveForm" label-width="100px">
        <el-form-item label="卡片名称" prop="name">
          <el-input maxlength="99" size="small" v-model="liveForm.name" placeholder="请输入卡片名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="卡片标题" prop="title">
          <el-input maxlength="99" size="small" v-model="liveForm.title" placeholder="请输入卡片标题" clearable></el-input>
        </el-form-item>
        <el-form-item label="卡片描述" prop="description">
          <el-input maxlength="99" size="small" v-model="liveForm.description" placeholder="请输入卡片描述" clearable></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="coverImg">
          <el-upload class="avatar-uploader" :before-upload="fileCheck" :http-request="upload" :show-file-list="false">
            <el-image v-if="liveForm.coverImg" :src="liveForm.coverImg" fit="scale-down" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="图片宽度尺寸">
          <el-radio-group v-model="liveForm.imgSelectWidth">
            <el-radio label="300">小图：300px (推荐)</el-radio>
            <el-radio label="700">大图：700px (推荐)</el-radio>
            <el-radio :label="-1">自定义图片宽度</el-radio>
          </el-radio-group>
          <el-popover placement="top" width="200" trigger="hover" content="如果输入了自定义图片宽度，以自定义图片宽度为准">
            <i class="el-icon-question" slot="reference" style="margin-left: 40px;color: #507dc5;"></i>
          </el-popover>
        </el-form-item>
        <el-form-item label=" " v-if="liveForm.imgSelectWidth === -1">
          <el-input size="small" v-model="liveForm.imgWidth" placeholder="请输入图片宽度(单位px)" clearable></el-input>
        </el-form-item>
        <el-form-item label="赛程列表" prop="items">
          <el-button size="small" @click="selectAppCards">选择</el-button>
          <avue-crud v-if="liveForm.items.length" style="width: 100%" :option="option" :data="liveForm.items" ref="crud"
            @sortable-change="sortChange">
            <!-- 自定义搜索框 -->
            <template slot="mySearch"> </template>
            <!-- 自定义表格列 -->
            <!-- 队伍信息 -->
            <template #teamA="{ row }">
              <span>{{ row.teamA }} VS {{ row.teamB }}</span>
            </template>
            <!-- 队伍图片 -->
            <template #teamAImg="{ row }">
              <div style="display: flex;align-items: center;">
                <el-image v-if="row.teamAImg" style="width: 100px; height: 100px" :src="row.teamAImg"
                  fit="scale-down"></el-image>
                VS
                <el-image v-if="row.teamBImg" style="width: 100px; height: 100px" :src="row.teamBImg"></el-image>
              </div>
            </template>
            <!-- 直播时间 -->
            <template #matchStartTime="{ row }">
              <span>{{ row.matchStartTime }} - {{ row.matchEndTime }}</span>
            </template>
            <!-- 操作按钮 -->
            <template #operation="{ row }">
              <el-button 
                type="text" 
                size="small" 
                :disabled="!canMoveUp(liveForm.items, row)" 
                @click="moveUp(row)"
              >
                上移
              </el-button>
              <el-button 
                type="text" 
                size="small" 
                :disabled="!canMoveDown(liveForm.items, row)" 
                @click="moveDown(row)"
              >
                下移
              </el-button>
              <el-button 
                type="text" 
                size="small" 
                :disabled="!canMoveTop(liveForm.items, row)" 
                @click="moveTop(row)"
              >
                置顶
              </el-button>
              <el-button 
                type="text" 
                size="small" 
                style="color: #f56c6c;" 
                @click="remove(row)"
              >
                移除
              </el-button>
            </template>
          </avue-crud>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input maxlength="9999" show-word-limit size="small" type="textarea" v-model="liveForm.remark"
            placeholder="请输入备注" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="liveForm.status">
            <el-radio :label="1">生效</el-radio>
            <el-radio :label="0">失效</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 生效模式 -->
        <el-form-item v-if="liveForm.status === 1" label="选择" prop="effectMode">
          <!-- 立即生效 1  指定时间生效 2 -->
          <el-radio-group v-model="liveForm.effectMode">
            <el-radio :label="1">立即生效</el-radio>
            <el-radio :label="2">指定时间生效</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 生效时间 -->
        <el-form-item v-if="liveForm.status === 1 && liveForm.effectMode === 2" label="生效时间" prop="effectTime">
          <el-date-picker size="small" :picker-options="{
            disabledDate(time) {
              return time.getTime() < Date.now() - 8.64e7;
            },
          }" v-model="liveForm.effectTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="至"
            start-placeholder="生效开始时间" end-placeholder="生效结束时间" clearable>
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <!-- 保存和取消 -->
    <div class="btn-container" style="text-align: right; margin-top: 20px">
      <el-button size="small" type="primary" @click="save">保存</el-button>
      <el-button size="small" @click="cancel">取消</el-button>
    </div>
    <RaceCard ref="raceCard" @save="getContentList"></RaceCard>
  </div>
</template>

<script>
import RaceCard from "./raceCard.vue";
import Message from "@/components/Message";
import axios from "axios";
import _ from 'lodash'
import { addAppCard, updateAppCard } from "@/api/apps/appCard";
import { formatAddLiveForm, validateImageWidth, updateImgUrl } from '../utils/helper'
import { moveUp, moveDown, moveTop, removeItem, canMoveUp, canMoveDown, canMoveTop } from "../utils/sortUtils";
export default {
  name: "WebSaaSSubjectForm",
  components: {
    RaceCard,
  },
  inject: ["optionType"],
  data() {
    return {
      liveForm: {
        /** 卡片名称 */
        name: "",
        /** 卡片标题 */
        title: "",
        /** 卡片描述 */
        description: "",
        /** 图片 */
        coverImg: "",
        /** 图片宽度 */
        imgWidth: "",
        /** 图片宽度选择 */
        imgSelectWidth: '300',
        /** 内容列表 */
        items: [],
        /** 备注 */
        remark: "",
        /** 状态 （1：生效；0：失效）*/
        status: "",
        /** 生效模式 1：立即生效；2：指定时间生效 */
        effectMode: "",
        /** 生效时间 */
        effectTime: [],
        /** 卡片类型 1：焦点卡片；2：直播卡片；3：导航卡片 8:直播卡片 */
        type: 8,
      },
      option: {
        lazy: true,
        tip: false,
        simplePage: true,
        searchShow: false,
        // searchMenuSpan: 6,
        tree: true,
        border: true,
        /** 表格索引 */
        index: false,
        /** 索引说明 */
        indexLabel: "No",
        /** 表格搜索显隐按钮 */
        searchShowBtn: false,
        /** 是否启用功能按钮 */
        searchIcon: false,
        searchIndex: 0,
        /** 表格查看按钮 */
        viewBtn: false,
        /** 表格新增按钮 */
        addBtn: false,
        /** 表格删除按钮 */
        delBtn: false,
        /** 表格修改按钮 */
        editBtn: false,
        /** 表格搜索按钮 */
        searchBtn: false,
        /** 表格清空按钮 */
        emptyBtn: false,
        /** 表格列操作按钮 */
        columnBtn: false,
        /** 表格刷新数据按钮 */
        refreshBtn: false,
        /** 开启拖拽功能 */
        sortable: true,
        // dragHandler: true,
        rowSort: true,
        columnSort: true,
        menu: false,
        menuWidth: 120,
        // menuFixed: true,
        column: [
          {
            label: "ID",
            prop: "id",
            width: 40,
          },
          {
            label: "队伍信息",
            prop: "teamA",
            overHidden: true,
            slot: true
          },
          {
            label: "队伍图片",
            prop: "teamAImg",
            slot: true,
            width: 140,
          },
          {
            label: "直播状态",
            prop: "liveStatus",
            // 1：未开始；2：直播中；3：已结束
            dicData: [
              {
                label: "未开始",
                value: 1,
              },
              {
                label: "直播中",
                value: 2,
              },
              {
                label: "已结束",
                value: 3,
              },
            ],
          },
          {
            label: "直播时间",
            prop: "matchStartTime",
            slot: true,
            overHidden: true,
          },
          {
            label: "关联应用",
            prop: "thirdPartyAppName",
            overHidden: true,
          },
          {
            label: "状态",
            prop: "status",
            dicData: [
              {
                label: "上架",
                value: 1,
              },
              {
                label: "下架",
                value: 0,
              },
            ],
          },
          {
            label: "操作",
            prop: "operation",
            width: 200,
            slot: true
          },
          {
            label: "",
            prop: "my",
            hide: true,
            showColumn: false,
            search: true,
            display: false,
            menuClassName: "myClass",
            searchslot: true,
          },
        ],
      },
      /** 表单验证规则 */
      rules: {
        /** 卡片名称 */
        name: [
          {
            required: true,
            message: "请输入卡片名称",
            trigger: "blur",
          },
        ],
        /** 卡片标题 */
        title: [
          {
            required: false,
            message: "请输入卡片标题",
            trigger: "blur",
          },
        ],
        /** 卡片描述 */
        description: [
          {
            required: false,
            message: "请输入卡片描述",
            trigger: "blur",
          },
        ],
        /** 图片 */
        coverImg: [
          {
            required: true,
            message: "请上传图片",
            trigger: "blur",
          },
        ],
        /** 赛程列表 */
        items: [
          {
            required: true,
            message: "请选择赛程列表",
            trigger: "change",
          },
          {
            type: "array",
            min: 1,
            message: "请至少选择一个赛程列表",
            trigger: "change",
          },
        ],
        /** 备注 */
        remark: [
          {
            required: false,
            message: "请输入备注",
            trigger: "blur",
          },
        ],
        /** 状态 （1：生效；0：失效）*/
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: "blur",
          },
        ],
        /** 生效模式 1：立即生效；2：指定时间生效 */
        effectMode: [
          {
            required: true,
            message: "请选择生效模式",
            trigger: "blur",
          },
        ],
        /** 生效时间 */
        effectTime: [
          {
            required: true,
            message: "请选择生效时间",
            trigger: "blur",
          },
        ],
      },
    };
  },

  methods: {
    /** 编辑的方法 */
    async edit(form) {
      console.log("编辑直播卡片的参数", form);
      const params = formatAddLiveForm(form);
      console.log("编辑直播卡片的参数", params);
      const { data } = await updateAppCard(params);
      console.log("编辑直播卡片的响应", data);
      if (data.code === 200) {
        Message.success("编辑成功");
        // debugger
        this.$emit("reload");
        this.$emit("close");
      }
    },
    /** 新增的方法 */
    async add(form) {
      console.log("新增直播卡片的参数", form);
      const params = formatAddLiveForm(form);
      console.log("新增直播卡片的参数", params);
      const { data } = await addAppCard(params);
      console.log("新增直播卡片的响应", data);
      if (data.code === 200) {
        Message.success("新增成功");
        this.$emit("close");
        this.$emit("reload");
      }
    },
    /** 重置表单值 */
    reset() {
      /** 清空表单 */
      this.liveForm = {
        /** 卡片名称 */
        name: "",
        /** 卡片标题 */
        title: "",
        /** 卡片描述 */
        description: "",
        /** 图片 */
        coverImg: "",
        /** 图片宽度 */
        imgWidth: "",
        /** 图片宽度选择 */
        imgSelectWidth: '300',
        /** 内容列表 */
        items: [],
        /** 备注 */
        remark: "",
        /** 状态 */
        status: "",
        /** 卡片类型 1：焦点卡片；2：直播卡片；3：导航卡片 8:直播卡片 */
        type: 8,
        /** 生效模式 1：立即生效；2：指定时间生效 */
        effectMode: "",
        /** 生效时间 */
        effectTime: [],
      };
      /** 清空表单验证规则 */
      this.$refs.liveForm.clearValidate();
    },
    /** 关闭的事件 */
    cancel() {
      this.$emit("close");
      /** 清空表单验证规则 */
      this.$refs.liveForm.clearValidate();
    },
    /** 保存的事件 */
    save() {
      this.$refs.liveForm.validate(async (valid) => {
        if (valid) {
          console.log("liveForm", this.liveForm);
          /** 保存 */
          console.log("直播卡片验证通过");
          /** 校验图片宽度 */
          if (!validateImageWidth(this.liveForm)) {
            return;
          }
          /** merge 对象防止响应式丢失 */
          _.merge(this.liveForm, updateImgUrl(this.liveForm));
          if (this.optionType.value === "add") {
            this.add(this.liveForm);
          } else {
            this.edit(this.liveForm);
          }
        } else {
          console.log("直播卡片验证失败");
          return false;
        }
      });
    },
    /** 上传图片校验 */
    fileCheck(file) {
      // 判断类型
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        Message.error("目前只支持jpg/png图片");
        return false;
      }
      // 判断大小
      if (file.size > 1024 * 1024 * 5) {
        Message.error("不能上传超过5M的图片");
        return false;
      }
    },
    /** 上传图片的方法 */
    async upload(params) {
      const file = params.file;
      let navForm = new FormData();
      navForm.append("file", file);
      try {
        const { data } = await axios.post(
          "/lebo-resource/oss/endpoint/put-file?code=lebotob",
          navForm,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log("上传图片的响应", data);
        const result = data.data;
        if (data.code === 200) {
          /** 上传成功 */
          /** 赋值 */
          this.liveForm.coverImg = result.link;
          /** 提示用户 */
          Message.success("上传成功");
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    /** 排序的事件 */
    sortChange(oldindex, newindex, row, list) {
      console.log("row", row);
      console.log("list", list);
      /** 只留下id */
      const items = list.map((item) => {
        return item.id;
      });
      console.log("排序之后的idList", items);
    },
    /** 选择内容列表 */
    selectAppCards() {
      console.log("选择内容列表", this.liveForm.items);
      this.$refs.raceCard.show([...this.liveForm.items]);
    },
    /** 接收选择内容列表 */
    getContentList(list) {
      console.log("getContentList", list);
      this.liveForm.items = list;
    },
    /** 上移 */
    moveUp(row) {
      moveUp(this.liveForm.items, row);
    },
    /** 下移 */
    moveDown(row) {
      moveDown(this.liveForm.items, row);
    },
    /** 置顶 */
    moveTop(row) {
      moveTop(this.liveForm.items, row);
    },
    /** 移除 */
    remove(row) {
      removeItem(this.liveForm.items, row);
    },
    /** 是否可以上移 */
    canMoveUp(items, row) {
      return canMoveUp(items, row);
    },
    /** 是否可以下移 */
    canMoveDown(items, row) {
      return canMoveDown(items, row);
    },
    /** 是否可以置顶 */
    canMoveTop(items, row) {
      return canMoveTop(items, row);
    },
  },
};
</script>

<style lang="scss" scoped>
.liveForm {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  ::v-deep .avatar-uploader .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    background-color: #f5f7fa;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }

  // ::v-deep .el-input__inner {
  //   width: 250px !important;
  // }
  ::v-deep .el-textarea__inner {
    min-height: 70px !important;
  }
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}

//^ ^--------------avue-crud的样式-------------^ ^
::v-deep .avue-crud__menu {
  display: none;
}

::v-deep .avue-crud .el-card {
  padding: 0 !important;
  overflow: auto !important;
}

.avue-crud .avue-input-number,
.avue-crud .el-cascader,
.avue-crud .el-date-editor.el-input,
.avue-crud .el-date-editor.el-input__inner,
.avue-crud .el-select,
.avue-form .avue-input-number,
.avue-form .el-cascader,
.avue-form .el-date-editor.el-input,
.avue-form .el-date-editor.el-input__inner,
.avue-form .el-select {
  width: 70% !important;
}

::v-deep .avue-form__menu--center {
  display: none !important;
}

::v-deep .avue-form__group .el-col-md-6 {
  width: 100%;
}

::v-deep .avue-form__group .el-form-item__content {
  margin-left: 0px !important;
}

::v-deep .avue-crud .avue-crud__search .avue-form .avue-form__group .avue-form__row .el-form-item label {
  float: none;
  display: inline-block;
}

::v-deep .avue-crud__pagination {
  display: none !important;
}
</style>